import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import routes, { programRoutes } from '@/app/routes';
import { RequireAuth } from './RequireAuth';
import { lazy, Suspense } from 'react';
import { LoadingOverlay } from '@mantine/core';
import { PageLayout } from './PageLayout';
import { EnvironmentBanner } from '@/shell/EnvironmentBanner/EnvironmentBanner';
import { Notifications } from '@mantine/notifications';
import AcceptInvite from './AcceptInvite';
import classes from './App.module.css';

const ProgramModalsProvider = lazy(
  () => import('@/views/program/ProgramModalsProvider')
);

const renderRouteElement = (route: (typeof routes)[number]) => {
  const Component = route.component;
  return (
    <Suspense
      fallback={
        <PageLayout>
          <LoadingOverlay
            visible
            overlayProps={{
              backgroundOpacity: 1,
            }}
          />
        </PageLayout>
      }
    >
      <Component {...route.props} />
    </Suspense>
  );
};

const App = () => {
  return (
    <Router>
      <Notifications />
      <div className={classes.appFrame}>
        <EnvironmentBanner />
        <div className={classes.appContent}>
          <Routes>
            <Route path="/accept-invite" element={<AcceptInvite />} />
            {routes.map((route) => (
              <Route
                key={route.key}
                path={route.path}
                element={<RequireAuth>{renderRouteElement(route)}</RequireAuth>}
              />
            ))}
            {/*
             * All of these routes are prefixed with `/program`. Here, we wrap
             * them in ProgramModalsProvider to help manage `global` modals.
             */}
            <Route
              element={
                <RequireAuth>
                  <ProgramModalsProvider />
                </RequireAuth>
              }
            >
              {programRoutes.map((route) => (
                <Route
                  key={route.key}
                  path={route.path}
                  element={renderRouteElement(route)}
                />
              ))}
            </Route>
            <Route path="*" element={<Navigate to="/404" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
